import { getBaseRouteName, routeTitles } from '@/utils/routeNames';
import Vue from 'vue';

export function setPageMeta(route, i18n, notificationCount) {
  // Get base route name without locale prefix
  const baseRouteName = getBaseRouteName(route);

  // Get the title key from routeTitles
  const titleKey = routeTitles[baseRouteName];

  // Set title in route meta and document, translate if it's a translation key
  let title = titleKey ? i18n.t(`page_title.${titleKey}`) : 'Skade';

  // Initialize meta object if it doesn't exist
  if (!route.meta) {
    Vue.set(route, 'meta', {});
  }
  title =
    notificationCount > 0
      ? `(${notificationCount > 99 ? '99+' : notificationCount}) ${title}`
      : title;

  // Use Vue.set to handle readonly route.meta properties
  Vue.set(route.meta, 'title', title);
  Vue.set(route.meta, 'titleKey', titleKey || 'Skade');
  Vue.set(route.meta, 'baseRouteName', baseRouteName);

  document.title = title;
}

export default function ({ app, store }) {
  app.router.beforeEach((to, from, next) => {
    const currentNotificationCount =
      store.getters['notifications/notificationCount'];

    setPageMeta(to, app.i18n, currentNotificationCount);
    next();
  });
}
